import type { AdminUser } from '../types';
import { Icon, Avatar, fmt } from '../atoms';
import { ORG } from '../data';

export function Storage({ users, onOpen }: { users: AdminUser[]; onOpen: (u: AdminUser) => void }) {
  const db = users.reduce((a, u) => a + u.db, 0);
  const s3 = users.reduce((a, u) => a + u.s3, 0);
  const rows = [...users].filter(u => u.db + u.s3 > 0).sort((a, b) => (b.db + b.s3) - (a.db + a.s3));
  const max = Math.max(...rows.map(u => u.db + u.s3));
  const largest = rows[0];

  const kpi = (icon: string, label: string, value: string, sub: React.ReactNode) => (
    <div className="card kpi">
      <div className="k-h"><span className="ic"><Icon name={icon} size={14} /></span>{label}</div>
      <div className="k-v">{value}</div>
      <div className="k-sub">{sub}</div>
    </div>
  );

  return (
    <>
      <div className="kpis">
        {kpi('hdd', 'Total storage', fmt.mb(db + s3), <span>across {ORG.totalUsers} users</span>)}
        {kpi('db', 'DynamoDB', fmt.mb(db), <span>items, notes, metadata</span>)}
        {kpi('cloud', 'S3', fmt.mb(s3), <span>attachments & captures</span>)}
        {kpi('gauge', 'Largest account', largest ? fmt.mb(largest.db + largest.s3) : '—',
          largest && <span>{largest.name}</span>)}
      </div>

      <div className="sec-h"><h2>By user</h2><span className="c">DB + S3, largest first</span></div>

      <div className="card" style={{ padding: '6px 18px' }}>
        <div className="chart-legend" style={{ padding: '12px 0 6px' }}>
          <span className="lg"><span className="sw" style={{ background: 'var(--info)' }} />DynamoDB</span>
          <span className="lg"><span className="sw" style={{ background: 'var(--accent)' }} />S3</span>
        </div>
        {rows.map(u => (
          <div key={u.id} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '12px 0', borderBottom: '1px solid var(--line)', cursor: 'pointer' }} onClick={() => onOpen(u)}>
            <Avatar size={30} hue={u.hue} initials={u.initials} />
            <div style={{ width: 150, flexShrink: 0 }}>
              <div style={{ fontSize: 13.5, fontWeight: 600 }}>{u.name}</div>
              {u.flags.includes('storage') && (
                <span className="badge warn" style={{ marginTop: 4 }}><span className="d" />Fast growth</span>
              )}
            </div>
            <div style={{ flex: 1 }}>
              <div className="stbar">
                <span className="db" style={{ width: (u.db + u.s3) / max * (u.db / (u.db + u.s3)) * 100 + '%' }} />
                <span className="s3" style={{ width: (u.db + u.s3) / max * (u.s3 / (u.db + u.s3)) * 100 + '%' }} />
              </div>
            </div>
            <div className="mono" style={{ width: 130, textAlign: 'right', fontSize: 13 }}>
              <span style={{ fontWeight: 700 }}>{fmt.mb(u.db + u.s3)}</span>
              <div style={{ fontSize: 10.5, color: 'var(--faint)' }}>{fmt.mb(u.db)} · {fmt.mb(u.s3)}</div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
